<template>
    <section class="c-text-banner">
        <div class="text-area">
            <div class="text-area-left">
                <slot></slot>
            </div>
            <div class="text-area-right">
                <slot name="right">
                    <p>
                        <span>申请人：{{ user.name }}</span>
                        <span class="ml-20">签约部门：{{ user.sysTypeName }}</span>
                    </p>
                </slot>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'textBanner',
        props: {
            iconType: String
        },
        computed: {
            user () {
                return this.$store.state.user
            }
        }
    }
</script>
<style lang="scss" scoped>
    .c-text-banner {
        position   : relative;
        height     : 195px;
        background : url('~images/banner/banner-1.jpg') no-repeat center center;
        .text-area {
            color    : #fff;
            position : absolute;
            bottom   : 10px;
            left     : 20px;
            right    : 20px;
            .title {
                font-size : 24px;
            }
            &-left {
                position : absolute;
                bottom   : 0;
                left     : 0;
            }
            &-right {
                max-width  : 700px;
                position   : absolute;
                bottom     : 0;
                right      : 0;
                word-break : break-all;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// textBanner.vue?24f3091a